module.exports = __webpack_public_path__ + "img/table_live.5c6b7385.png";